import { AfterViewInit, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfigProvider } from "../../../config-provider.service";
import { MatCard, MatCardContent, MatCardImage, MatCardTitle } from "@angular/material/card";
import { NgForOf, NgIf, NgOptimizedImage } from "@angular/common";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { MatFabButton, MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { MatProgressBar } from "@angular/material/progress-bar";
import { ModuleMenu } from "../../models/menu";

@Component({
  selector: 'module-content',
  providers: [],
  styleUrls: ['./module-content.scss'],
  standalone: true,
  imports: [
    MatCard,
    NgIf,
    MatCardImage,
    NgOptimizedImage,
    MatCardTitle,
    TranslateModule,
    MatMenuTrigger,
    MatIconButton,
    MatIcon,
    NgForOf,
    MatTooltip,
    MatMenu,
    MatMenuItem,
    MatCardContent,
    MatFabButton,
    MatProgressBar
  ],
  templateUrl: './module-content.html'
})
export class ModuleContentComponent implements AfterViewInit {
    @Input() public title = '';
    @Input() public titleSwitcher: ModuleMenu[] = [];
    @Input() public moreMenus: ModuleMenu[] = [];
    @Input() public shortcutMenus: ModuleMenu[] = [];
    @Input() public mainActions: ModuleMenu[] = [];
    @Input() public mainActionsPosition: 'top' | 'bottom' = 'bottom';
    @Input() public coverImage: string | null = null;
    @Input() public isLoading = false;
    @Input() public loaderPosition: 'top' | 'bottom' = 'bottom';
    @Input() public disableMainActionsWhenLoading = true;
    constructor(
        public conf: ConfigProvider,
        private _router: Router,
        private _translater: TranslateService
    ) {
    }

    public ngAfterViewInit() {
    }

    public onMenuClicked(menu: ModuleMenu): void {

        if (menu.onClick) {
            menu.onClick();
        } else if (menu.url) {
            this._router.navigateByUrl(menu.url);
        }
    }
}

